module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe-wechat4_cn@3x.c2640023.png";